/* unplugin-vue-components disabled */import script from "./ShowcaseUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShowcaseUser.vue?vue&type=script&lang=ts&setup=true"

import "./ShowcaseUser.vue?vue&type=style&index=0&id=40f73f6e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f73f6e"]])

export default __exports__